import { productImageCarouselStyles as styles } from "@insite/content-library/Components/ProductImageCarousel";
import { IconWrapper } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { buttonIconOnlyCommonStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.prevArrowButton = {
    ...styles.prevArrowButton,
    ...buttonIconOnlyCommonStyles,
};

styles.nextArrowButton = {
    ...styles.nextArrowButton,
    ...buttonIconOnlyCommonStyles,
};
